import { Alert } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const ErrorResources = Resources.TransactionErrors;

export type StatusAlertKind = "paid" | "cancelled";

const STATUS_TO_ALERT_CONFIG = {
  paid: {
    severity: "success" as const,
    variant: "outlined" as const,
    messageKey: ErrorResources.TransactionAlreadyCompleted,
  },
  cancelled: {
    severity: "error" as const,
    variant: "filled" as const,
    messageKey: ErrorResources.TransactionCancelled,
  },
} satisfies Record<StatusAlertKind, unknown>;

type Props = {
  status: StatusAlertKind;
};

export const TransactionStatusAlert = ({ status }: Props) => {
  const { t } = useResource();
  const { severity, variant, messageKey } = STATUS_TO_ALERT_CONFIG[status];

  return (
    <Alert severity={severity} variant={variant}>
      {t(messageKey)}
    </Alert>
  );
};
